import { Component, ComponentFactoryResolver } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { DocumentoVendaDataService } from 'src/app/core/services/documentoVenda-crud.service';
import { BrowseComponent } from 'src/app/shared/components/browse/browse.component';
import { DataGridColumn } from 'src/app/shared/components/datagrid/datagrid-core.component';
import { DocumentoVenda } from 'src/app/model/documentoVenda/documentoVenda';
import { DocumentoVendaSearchFilter } from 'src/app/model/documentoVenda/documentoVendaSearchFilter';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentoVendaBrowseFilterComponent } from './documentoVenda-browse-filter.component';

@Component({
    selector: 'app-documentovenda-browse',
    templateUrl: '../../../shared/components/browse/browse.component.html',
    standalone: false
})
export class DocumentoVendaBrowseComponent extends BrowseComponent<DocumentoVenda> {

  constructor(
    protected componentFactoryResolver: ComponentFactoryResolver,
    protected router: Router, protected route: ActivatedRoute,
    protected modalService: NgbModal,
    protected dataService: DocumentoVendaDataService) {

    super(componentFactoryResolver, router, route, modalService, dataService);

    this.title = 'Documentos';
    this.componentFilter = DocumentoVendaBrowseFilterComponent;
    this.browseRouterLink = '/documentos';
    this.manageRouterLink = '/documentos';
    this.globalMessage = '** Para documentos não disponíveis deverá solicitar cópia através do email contabilidade@boxer.pt';
    this.showAdd = false;
    this.canDelete = false;
    this.canDeleteHandler = false;
    this.showExportExcel = false;
    this.autoFilter = false;

    this.filter = new DocumentoVendaSearchFilter();
    this.filter.pageNumber = 1;
    this.filter.pageSize = 10;
    this.filter.returnTotalCount = true;

    this.columns.push(
      new DataGridColumn(
        'numDocumento', 'Nº Documento',
        '[{"width": "130px","hyperLink": false}]'
      ));

    this.columns.push(
      new DataGridColumn(
        'dataDocumento', 'Data Documento',
        '[{"width": "150px", "textAlign": "center", "formatDate": true }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'dataVencimento', 'Data Vencimento',
        '[{"width": "150px", "textAlign": "center", "formatDate": true }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'valorSemIva', 'Valor Base',
        '[{"width": "100px", "textAlign": "right", "formatMoney": true }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'valorIva', 'Valor Iva',
        '[{"width": "100px", "textAlign": "right", "formatMoney": true }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'valorTotal', 'Valor Total',
        '[{"width": "100px", "textAlign": "right", "formatMoney": true }]'
      ));

    // this.columns.push(
    //   new DataGridColumn(
    //     'valorEmAberto', 'Valor Pendente',
    //     '[{"width": "100px", "textAlign": "right", "formatMoney": true }]'
    //   ));

    this.columns.push(
      new DataGridColumn(
        '', '',
        '[{"width": "2%", "hyperLink": false, "singleButton": true, "buttonText": "downloadPdf", "buttonDownloadPdf": true }]'
      ));

    this.columns.push(
      new DataGridColumn(
        '', '',
        '[{"width": "2%", "hyperLink": false, "singleButton": true, "buttonText": "downloadExcel", "buttonDownloadExcel": true }]'
      )
    );
  }
}
